module.exports = __webpack_public_path__ + "static/media/9C.bb4c0473.png";